var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnFloatingPrevDisable = function SvgBtnFloatingPrevDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.333 12-4.242 4.243 4.242 4.242",
    stroke: "#000",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBtnFloatingPrevDisable;